// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"style_sectionWrapper__FxWb3","gradientOverlay":"style_gradientOverlay__LxUVD","innerGradient":"style_innerGradient__T5KCj"};